<template>
  <div class="task-super" :class="{'task-not-bo': activeName === 'task' && (taskModeCheck.components == 'TableNew' || taskModeCheck.components == 'Gantt') }">
    <basiCcontainer @scroll="lineLoaidngData">
      <template #head>
        <!-- 面包屑 -->
        <Breadcrumb
          :projectInfo="projectInfo"
          :fromPathName="fromPathName"
          @starSuccess="getProjectDetail"
          @taskClick="taskClick"
          @templateKeyChange="templateKeyChange"
        ></Breadcrumb>

        <div class="tabs-box">
          <el-tabs v-model="activeName" :before-leave="handleBeforeTabChange">
            <el-tab-pane label="任务" name="task"> </el-tab-pane>
            <el-tab-pane label="统计" name="statistics"> </el-tab-pane>
            <el-tab-pane label="文件" name="file"> </el-tab-pane>
          </el-tabs>
          <div class="tabs-right-box" v-if="!loading">
            <TaskFilterBox v-if="activeName === 'task'" :projectId="projectId"></TaskFilterBox>
            <CloudFilterBox v-if="activeName === 'file'"></CloudFilterBox>
          </div>
        </div>
      </template>
      <template v-if="activeName === 'task'">
        <div  class="task-super-content" v-if="taskModeCheck.components && !loading">
          <component :is="taskModeCheck.components" :projectId="projectId" @addTaskList="addTaskList" @taskClick="taskClick" ref="taskList"></component>
        </div>
      </template>
      <statistics  v-else-if="activeName === 'statistics'" :projectId="projectId"></statistics>
      <FileManagement v-else :fileTreesId="fileTreesId" :fileCreatePermission="fileCreatePermission" :cancelUpload="cancelUpload" @uploading="fileUploading"></FileManagement>
    </basiCcontainer>
    <AddTask v-model="visibleAddTask" :pid="pid" :project_id="projectId" :task_list_id="task_list_id" @addSuccess="addSuccess"></AddTask>
    <AddChecklist :projectId="projectId" @success="addTaskListSuccess" v-model="visibleAddChecklist"></AddChecklist>
    <el-tooltip v-if="isAdmin && activeName === 'task' && !isCheckStatus && !isDisabledProject" class="task-list-add" effect="dark" content="添加任务清单" placement="top">
      <div @click="addTaskList">
        <i class="icon iconfont iconicon_enlarge"></i>
      </div>
    </el-tooltip>
    <el-drawer
      custom-class="project-setting-drawer"
      :visible.sync="editVisible"
      :wrapperClosable="false"
      :title="projectDetailVisible ? '项目详情' : '编辑项目'"
    >
      <EditView
        :dataset="projectInfo"
        @getProjectDetail="getProjectDetail"
        :editVisible="editVisible"
        :projectDetailVisible="projectDetailVisible"
        @projectSuccess="projectSuccess"
        @delSuccess="delSuccess"
      />
    </el-drawer>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import proApi from "@/services/api/project/project";
import { Storage } from "@/utils/utils";
import bus from "@/bus.js";
import TopTool from "../topTool";
import Board from "./boardNew";
// import Table from "./table";
import TableNew from './tableNew'
import AddChecklist from "../addChecklist";
import EditView from "../editView";
import TaskFilterBox from "./filterBox";
import statistics from "@/views/statistics";
import Gantt from "./ganttNew";
import AddTask from "../taskPanel/addTask";
import FileManagement from "@/views/fileManagement";
import Breadcrumb from './breadcrumb/index.vue'
import CloudFilterBox from '@/views/fileManagement/filterBox'
export default {
  components: {
    TopTool,
    Board,
    // Table,
    AddChecklist,
    EditView,
    TaskFilterBox,
    statistics,
    Gantt,
    AddTask,
    FileManagement,
    Gantt,
    TableNew,
    Breadcrumb,
    CloudFilterBox
  },
  data() {
    return {
      loading: false,
      projectId: "",
      activeName: "task",
      projectInfo: {},
      visibleAddTask: false,
      task_list_id: "",
      taskId: "",
      pid: 0,
      taskIsEdit: false,
      classmodel: "",
      visibleTaskInfo: false,
      isNeedRefes: false,
      editVisible: false,
      projectDetailVisible: false,
      visibleAddChecklist: false,
      filterTitleData: [],
      newActive: -1,
      fileTreesId: null, //文件树id
      fileCreatePermission: false, //项目文件新建文件夹权限
      uploading: false, //是否有文件上传中
      cancelUpload: false,
      fromPathName: 'myTask', //上一级路由的name，默认为工作台
    };
  },
  beforeRouteEnter (to, from, next) {
    next( vm => {
      // console.log(from, 111)
      vm.fromPathName = from.name
    })
  },
  watch: {
    $route: {
      async handler() {
        this.projectId = this.$route.query.projectId;
        try {
          await this.init()
          let result = await proApi.getProjectDetail({ project_id: this.projectId })
          this.set_disabled_project(result.status === -2 || result.is_archived === 1)
          this.projectInfo = result;
          this.fileTreesId = result.file_tree.id; //获取文件树id
          bus.$emit("projectId", result.project_id);
          this.change_tag_label({projectId: this.projectId, label: result.title})
          this.set_taskModeCheck(result.default_view - 1)
        } catch (error) {
          console.log('--------------', error);
          this.$router.go(-1)
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed:{
    ...mapState('task/task', {
      taskModeCheck: state => state.taskModeCheck,
      isCheckStatus: state => state.isCheckStatus,
      isDisabledProject: state => state.isDisabledProject
    })
  },
  beforeDestroy() {
    bus.$off("editVisible");
    bus.$off("projectDetailVisible");
    bus.$off("goToRecycleBin");
    bus.$off("filterTitleData");
    bus.$off("addTask");
  },
  created() {
    this.projectId = this.$route.query.projectId;
    this.activeName = this.$route.query.isStatistics ? 'statistics' : 'task' // 判断是否需要进入统计页面
    bus.$on("editVisible", () => {
      this.editVisible = true;
    });
    bus.$on("projectDetailVisible", () => {
      this.editVisible = true;
      this.projectDetailVisible = true;
    })
    bus.$on("goToRecycleBin", () => {
      // 进入任务回收站
      this.$router.push(`./recycleBin?projectId=${this.projectId}`)
    });
    bus.$on("filterTitleData", (data) => {
      this.filterTitleData = data;
    });
    bus.$on('addTask', item => {
      this.addTask(item)
    })
  },
  mounted() {
    // console.log("父组件执行、、、、、、、、");
    // this.init();
  },
  methods: {
    ...mapActions("project/project", ["getNewProjectMember"]),
    ...mapMutations("task/task", [  "CHANGE_TASK",'set_taskModeCheck','clear_task_query', 'set_disabled_project']),
    ...mapActions('task/task', ['getFilter']),
    ...mapMutations('tags/tags', ['change_tag_label']),
    lineLoaidngData(e) {
      // 列表加载更多清单
      this.$refs.taskList.taskListLoading ? this.$refs.taskList.taskListLoading(e) : "";
    },
    async init() {
      this.loading = true;
      await this.getFilter({project_id: this.projectId})
      // await this.getProjectDetail();
      await this.getNewProjectMember({ project_id: this.projectId, working_status: "在职" });
      this.loading = false;
    },
    getProjectDetail() {
      return proApi
        .getProjectDetail({ project_id: this.projectId })
        .then((res) => {
          this.set_disabled_project(res.status === -2 || res.is_archived === 1)
          this.projectInfo = res;
          bus.$emit("projectId", res.project_id);
          this.fileTreesId = res.file_tree.id; //获取文件树id
          this.fileCreatePermission = res.file_tree.create_folder_permission; //获取是否在项目文件新建文件夹权限
          this.change_tag_label({projectId: this.projectId, label: res.title})
          this.set_taskModeCheck(res.default_view - 1)
        })
        .catch((err) => {
          console.log('--------------', err);
          this.$router.go(-1)
        });
    },
    addTask({task_list_id, id}) {
      this.task_list_id = task_list_id;
      this.pid = id || 0
      this.visibleAddTask = true;
      this.taskIsEdit = false;
    },
    editTask(id) {
      this.taskId = id;
    },
    addSuccess(id) {
      this.visibleAddTask = false;
      this.$refs.taskList.addSuccess(this.task_list_id, id, this.pid);
    },
    // 监测抽屉鼠标事件
    handleWrapperMousedown(e) {
      // 如果为true，则表示点击发生在遮罩层
      this.classmodel = !!e.target.classList.contains("el-drawer__container");
    },
    handleWrapperMouseup(e) {
      if (!!e.target.classList.contains("el-drawer__container") && this.classmodel) {
        this.visibleTaskInfo = false;
      } else {
        this.visibleTaskInfo = true;
      }
      this.classmodel = false;
    },
    viewEnd(isNeedRefes) {
      if (isNeedRefes) {
        bus.$emit("taskChangeData", { task_id: this.taskId, task_list_id: this.task_list_id });
      }
    },
    taskClick({ task_list_id, task_id }) {
      this.task_list_id = task_list_id;
      this.taskId = task_id;
      this.taskIsEdit = true;
      this.visibleTaskInfo = true;
      this.CHANGE_TASK({ visible: true, task_id, task_list_id });
    },
    addTaskList() {
      this.visibleAddChecklist = true;
    },
    addTaskListSuccess() {
      this.visibleAddChecklist = false;
      this.$refs.taskList.restData();
    },
    projectSuccess() {
      this.getProjectDetail();
      this.editVisible = false;
    },
    delSuccess(fl) {
      if (fl) {
        this.getProjectDetail()
        this.editVisible = false
      } else {
        this.$router.go(-1);
      }
    },
    statusChange(status) {
      bus.$emit("statusChange", status);
    },
    taskChange(id, index) {
      bus.$emit("taskChange", id, index);
    },
    templateKeyChange() {
      this.$refs.taskList.restData();
    },
    fileUploading(val) {
      this.uploading = val;
    },
    handleBeforeTabChange(activeName, oldActiveName) {
      this.clear_task_query()
      if (oldActiveName === "file" && this.uploading) {
        const fn = new Promise((resolve, reject) => {
        this.$wfAlert('', '离开此页面?', '系统可能不会保存您所做的更改').then(() => {
            this.cancelUpload = true;
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
        });
        return fn;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clear_task_query()
    if (this.activeName === "file" && this.uploading) {
      //文件管理页面并且有文件上传中
      this.$wfAlert('', '离开此页面?', '系统可能不会保存您所做的更改').then(() => {
          this.cancelUpload = true;
          next();
        })
        .catch(() => {
          next(false);
        });
    } else {
      next();
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.tasklist-title-more {
  .del {
    color: #FF3939 !important;
    i {
      margin-right: 8px;
      color: #FF3939 !important;
    }
    &:hover {
      background-color: rgba(255, 57, 57, 0.08) !important;
    }
    &:active {
      background-color: rgba(255, 57, 57, 0.16) !important;
      color: #FF3939 !important;
    }
  }
}
.task-super {
  // .el-dropdown-link {
  //   display: inline-block;
  //   height: 32px;
  //   padding: 0 8px;
  //   font-size: 12px !important;
  //   .iconicon_arrow_task {
  //     display: none;
  //     margin-left:23px;
  //     color:#75748E;
  //   }
  //   &:hover {
  //     .iconicon_enlarge {
  //       color: #509aff;
  //     }

  //   }
  // }
  .task-add-list {

  }
  > .basic-container {
    .search-box {
      border: 0 none;
    }
    .el-card {
      &::-webkit-scrollbar-track-piece {
        background-color: #E6E6E6;
      }
      &::-webkit-scrollbar {
        width: 6px;
        height: 24px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 0;
        background-color: #D5D5D5;
        &:active, &:hover {
          background-color: #9199A7;
        }
      }
    }
  }
  .search-box {
    // box-shadow: initial;
  }
  .tabs-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 0 none;
    position: relative;
    z-index: 3;
    padding-right: 27px;
    .el-tabs {
      margin-left: 28px;
      .el-tabs__item {
        font-size: 14px;
        font-weight: 500;
        @include fontColorOpacity(.6);
        &:hover {
          color: initial;
        }
      }
      .el-tabs__item.is-active {
        color: initial;
      }
    }
  }
  .task-super-content {
    height: 100%;
    position: relative;
    &::after {
      content: "";
    }
  }
  .task-list-add {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    background: linear-gradient(225deg, #2fa9ff 0%, #0d70e8 100%);
    position: absolute;
    right: 48px;
    bottom: 48px;
    line-height: 66px;
    text-align: center;
    box-shadow: 4px 6px 18px -3px #2fa9ff;
    cursor: pointer;
    z-index: 99;
    &:hover {
      background: linear-gradient(225deg, #107ce7 0%, #0764d4 100%);
    }
    i {
      color: #fff;
      margin: 0;
      font-size: 26px;
    }
  }
  .map-mode {
    margin-right: 10px;
    .el-dropdown-link {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      font-size: 12px;
      padding: 0;
    }
  }
  .ckeck-box {
    border-radius: 4px;
    height: 32px;
    border: 1px solid #e7e8ed;
    line-height: 32px;
    padding: 0 12px;
    box-sizing: border-box;
  }
  .tabs-right-box {
    display: flex;
  }
}
.task-not-bo .el-card{
  overflow: visible;
}
.task-drop-item > i.iconfont {
  margin-right: 12px;
  color: rgba(32, 32, 32, 0.8);
  font-weight: 400;
}
</style>
